export interface FoodBeverageReview {
  name: string;
  initials: string;
  color: string;
  badges: string[];
  rating: number;
  date: string;
  text: string;
  helpful: number;
}

export const foodBeverageReviews: Record<string, FoodBeverageReview[]> = {
  gopuff: [
    {
      name: 'Marcus T.',
      initials: 'MT',
      color: 'bg-emerald-500',
      badges: ['Verified'],
      rating: 5,
      date: 'Feb 2026',
      text: 'Gopuff has become an absolute lifesaver for those late-night cravings and forgotten grocery runs. I live in Brooklyn and my orders consistently arrive in under 20 minutes. The Fam membership pays for itself after just 3–4 orders a month. Selection is impressive too — from protein bars to laundry detergent, it feels like a mini convenience store at my fingertips.',
      helpful: 87,
    },
    {
      name: 'Priya N.',
      initials: 'PN',
      color: 'bg-teal-500',
      badges: ['Verified', 'Fam Member'],
      rating: 4,
      date: 'Jan 2026',
      text: 'Really solid service for quick essentials. I especially love that pricing is consistent — no surge pricing unlike some ride-share based delivery apps. My only complaint is that they ran out of a few popular items during the holidays, but that seems like a seasonal issue. Overall, highly recommended for urban dwellers who value time.',
      helpful: 64,
    },
    {
      name: 'Jake L.',
      initials: 'JL',
      color: 'bg-cyan-500',
      badges: ['Verified'],
      rating: 5,
      date: 'Dec 2025',
      text: 'The 24/7 availability is unmatched. I work night shifts and Gopuff is literally the only delivery option at 2am that doesn\'t feel like a sketchy choice. Got snacks, energy drinks, and even ibuprofen delivered at 3am once. That\'s just incredible. The app is super clean and the tracking is accurate.',
      helpful: 112,
    },
  ],
  'natures-lab': [
    {
      name: 'Dr. Sarah K.',
      initials: 'SK',
      color: 'bg-green-600',
      badges: ['Verified', 'Healthcare'],
      rating: 5,
      date: 'Feb 2026',
      text: "I recommend Nature's Lab to patients looking for quality supplements without the pharmacy markup. Their Magnesium Glycinate and Vitamin D3+K2 formulas are exceptional — I've tested the quality and it stands up to much pricier competitors. The transparent labeling means I can verify exactly what my patients are getting, which is critical in my practice.",
      helpful: 143,
    },
    {
      name: 'Ryan M.',
      initials: 'RM',
      color: 'bg-emerald-600',
      badges: ['Verified'],
      rating: 4,
      date: 'Jan 2026',
      text: "Switched from a big-box brand Omega-3 to Nature's Lab and honestly can't believe the difference in quality. No fishy aftertaste, the capsules are easy to swallow, and I feel the difference in my recovery times after workouts. Price is fair for what you get. Wish they shipped internationally more affordably, but the product quality is top tier.",
      helpful: 89,
    },
    {
      name: 'Elena W.',
      initials: 'EW',
      color: 'bg-teal-600',
      badges: ['Verified', 'Subscriber'],
      rating: 5,
      date: 'Nov 2025',
      text: "Their Six Daily Advanced Multi-Vitamin is the best multivitamin I've ever used — and I've tried dozens. I actually notice the difference: better energy, clearer skin, improved mood. The fact that it's cGMP certified and third-party tested gives me peace of mind. I'm a monthly subscriber now and will never go back to drugstore brands.",
      helpful: 97,
    },
  ],
  'paleo-on-the-go': [
    {
      name: 'Jessica H.',
      initials: 'JH',
      color: 'bg-amber-500',
      badges: ['Verified', 'AIP'],
      rating: 5,
      date: 'Feb 2026',
      text: "As someone managing Hashimoto's thyroiditis, finding compliant AIP meals was a constant struggle until I found Paleo On The Go. Their meals are genuinely delicious — not just 'healthy but tasteless.' The turkey meatballs with cassava spaghetti and their chicken soup are absolute favorites. Having a freezer stocked with these gives me such peace of mind on my busiest days.",
      helpful: 156,
    },
    {
      name: 'Tom R.',
      initials: 'TR',
      color: 'bg-orange-500',
      badges: ['Verified'],
      rating: 4,
      date: 'Jan 2026',
      text: "Quality is exceptional and the ingredient sourcing is clearly taken seriously. I've tried most Paleo meal delivery services and this is firmly in the top tier. The only thing that stops me giving 5 stars is the shipping cost — it adds up if you're buying small quantities. But when I bulk order, the value is definitely there.",
      helpful: 78,
    },
    {
      name: 'Amanda C.',
      initials: 'AC',
      color: 'bg-rose-500',
      badges: ['Verified', 'Subscriber'],
      rating: 5,
      date: 'Dec 2025',
      text: 'My husband and I both do AIP for health reasons and this service has been transformative for our weekly meal planning. The rotating seasonal menu keeps things exciting and we genuinely look forward to each delivery. Customer service is also excellent — they accommodated a special dietary restriction note without any hassle. Highly recommend!',
      helpful: 104,
    },
  ],
  'petes-paleo': [
    {
      name: 'Chris B.',
      initials: 'CB',
      color: 'bg-lime-600',
      badges: ['Verified', 'Farmer\'s Market Fan'],
      rating: 5,
      date: 'Feb 2026',
      text: "Pete's Paleo genuinely changed how I think about meal delivery. I grew up on farm-fresh food and most delivery services feel disappointingly industrial by comparison. These meals taste like they came from a farmers market kitchen — the quality of the proteins especially is extraordinary. The duck confit and the braised short rib are legitimately restaurant-quality.",
      helpful: 134,
    },
    {
      name: 'Nina P.',
      initials: 'NP',
      color: 'bg-green-600',
      badges: ['Verified', 'Whole30'],
      rating: 4,
      date: 'Jan 2026',
      text: "I used Pete's during my first Whole30 and it made compliance so much easier. The food is genuinely satisfying and flavorful, which matters a lot when you're restricting. Portion sizes are generous and the ingredients are clearly premium. Slightly pricey but the farm sourcing justifies it. I'd choose this over meal prepping myself any day.",
      helpful: 88,
    },
    {
      name: 'Derek S.',
      initials: 'DS',
      color: 'bg-teal-600',
      badges: ['Verified'],
      rating: 5,
      date: 'Nov 2025',
      text: "The weekly rotating menus based on seasonal farm availability is such a clever concept. It means you're always eating what's at peak freshness and flavor. I've been subscribed for 6 months and the quality has been completely consistent. This is the meal delivery service for people who actually care about where their food comes from.",
      helpful: 99,
    },
  ],
  'nutri-genetix': [
    {
      name: 'Oliver M.',
      initials: 'OM',
      color: 'bg-teal-500',
      badges: ['Verified', 'DNA Customer'],
      rating: 5,
      date: 'Feb 2026',
      text: "The science behind Nutri-Genetix genuinely impressed me — I'm a biochemist and I expected marketing fluff, but the genetic report they produced was thorough and evidence-based. My personalized BodyFuel formula addresses my specific methylation gene variants and it's made a noticeable difference in my energy levels and recovery. Worth every penny if you're serious about optimizing health.",
      helpful: 119,
    },
    {
      name: 'Sophie L.',
      initials: 'SL',
      color: 'bg-cyan-500',
      badges: ['Verified'],
      rating: 4,
      date: 'Jan 2026',
      text: 'Really fascinating concept and the execution is excellent. My protein formula tastes great and I like knowing it\'s made for my specific genetic profile. The DNA report took about 3 weeks to arrive which felt long, but the wait was worth it. Slightly expensive but if you consider how much you save by not buying the wrong supplements, the economics make sense.',
      helpful: 76,
    },
    {
      name: 'James F.',
      initials: 'JF',
      color: 'bg-emerald-500',
      badges: ['Verified', 'Athlete'],
      rating: 5,
      date: 'Dec 2025',
      text: "As an endurance athlete I've spent years experimenting with different protein and recovery supplements. NGX is the first product that actually felt tailored to how MY body responds — because it is. My personalized formula focuses on my specific carbohydrate metabolism and recovery needs based on my genes. Performance has noticeably improved since switching.",
      helpful: 143,
    },
  ],
  'simply-straws': [
    {
      name: 'Maya K.',
      initials: 'MK',
      color: 'bg-emerald-500',
      badges: ['Verified', 'Eco Advocate'],
      rating: 5,
      date: 'Feb 2026',
      text: "Simply Straws was my entry point into zero-waste living and I couldn't have asked for a better starting product. The glass straws are absolutely beautiful — I actually get compliments on them at restaurants when I pull one out! They're sturdy, easy to clean, and have completely replaced single-use plastics in my household. The gift sets make amazing presents for eco-conscious friends.",
      helpful: 89,
    },
    {
      name: 'Ben T.',
      initials: 'BT',
      color: 'bg-green-500',
      badges: ['Verified'],
      rating: 4,
      date: 'Jan 2026',
      text: "Good quality glass straws that hold up well over time. I've had mine for over a year and they look as good as new. The cleaning brush that comes with them works perfectly. My only note is to handle with a bit more care when traveling — I did break one once by dropping it. But for home use, absolutely 5 stars.",
      helpful: 67,
    },
    {
      name: 'Zoe C.',
      initials: 'ZC',
      color: 'bg-teal-500',
      badges: ['Verified', 'Smoothie Lover'],
      rating: 5,
      date: 'Nov 2025',
      text: "Bought the wide smoothie straws and they're absolutely perfect. No more struggling with thin straws for thick acai bowls and smoothies. The glass is high quality and doesn't affect taste the way metal straws sometimes can. Knowing that part of my purchase goes to ocean conservation makes me feel even better about this brand. 100% recommend!",
      helpful: 102,
    },
  ],
  parisrhone: [
    {
      name: 'Linda P.',
      initials: 'LP',
      color: 'bg-slate-600',
      badges: ['Verified'],
      rating: 5,
      date: 'Feb 2026',
      text: "I bought the PARIS RHÔNE air fryer 8 months ago and it's genuinely one of the best kitchen purchases I've made. The design looks stunning on my countertop and it performs beautifully — crispy food without the oil guilt. The app connectivity is a nice bonus for setting timers remotely. Customer service was also excellent when I had a setup question. Highly recommend!",
      helpful: 167,
    },
    {
      name: 'Carlos R.',
      initials: 'CR',
      color: 'bg-gray-600',
      badges: ['Verified', 'Home Chef'],
      rating: 4,
      date: 'Jan 2026',
      text: 'Fantastic kitchen appliances that outperform brands costing twice as much. The toaster oven is my daily workhorse — even heating, precise temperature control, and the convection mode is excellent. Design is genuinely premium. Docking one star only because the smart app has occasional connectivity hiccups, but the core appliance performance is flawless.',
      helpful: 128,
    },
    {
      name: 'Aisha M.',
      initials: 'AM',
      color: 'bg-zinc-600',
      badges: ['Verified', 'Interior Design'],
      rating: 5,
      date: 'Dec 2025',
      text: "Finally, a kitchen appliance brand that takes aesthetics as seriously as performance! I've replaced three different brands with PARIS RHÔNE products and my kitchen now looks cohesive and modern. The electric kettle especially is a design masterpiece. Boils water quickly, keeps temperature precisely, and looks gorgeous. I get compliments from guests constantly.",
      helpful: 94,
    },
  ],
  'restaurant-com': [
    {
      name: 'Nancy W.',
      initials: 'NW',
      color: 'bg-red-500',
      badges: ['Verified', 'Foodie'],
      rating: 5,
      date: 'Feb 2026',
      text: "Restaurant.com has completely changed how my family dines out. We go out 3–4 times a month and always check here first. The savings are real and substantial — I got a $25 voucher for a great Italian restaurant for $10. Over the year I've easily saved several hundred dollars while actually eating at better restaurants than I might have otherwise tried. Excellent service!",
      helpful: 198,
    },
    {
      name: 'Tom H.',
      initials: 'TH',
      color: 'bg-rose-500',
      badges: ['Verified'],
      rating: 4,
      date: 'Jan 2026',
      text: "Solid concept that genuinely delivers savings. A few caveats: check the restrictions on each voucher carefully because some have blackout dates or minimum spend requirements. That said, when you find a great deal at a good restaurant, the value is genuinely impressive. I discovered several amazing neighborhood restaurants I never would have tried otherwise. Great discovery tool too!",
      helpful: 145,
    },
    {
      name: 'Grace S.',
      initials: 'GS',
      color: 'bg-pink-500',
      badges: ['Verified', 'Gift Buyer'],
      rating: 4,
      date: 'Nov 2025',
      text: "Bought Restaurant.com gift cards for both parents last Christmas and they absolutely loved it. My mom discovered three new restaurants near her that she visits regularly now. The gift cards are a smart present for people who love dining out. The voucher system is easy to understand once you read the terms. Genuinely useful gift platform.",
      helpful: 112,
    },
  ],
  'lvly-sea': [
    {
      name: 'Chloe T.',
      initials: 'CT',
      color: 'bg-pink-500',
      badges: ['Verified', 'Corporate Buyer'],
      rating: 5,
      date: 'Feb 2026',
      text: "LVLY has become our company's go-to gifting partner for client appreciation and staff recognition. The arrangements are consistently stunning and the same-day delivery in Singapore has never let us down, even for urgent requests. The packaging is beautiful and eco-friendly which aligns with our brand values. The bespoke hamper building option is excellent for customized corporate gifting.",
      helpful: 134,
    },
    {
      name: 'Daniel K.',
      initials: 'DK',
      color: 'bg-rose-500',
      badges: ['Verified'],
      rating: 5,
      date: 'Jan 2026',
      text: "Ordered a birthday bouquet for my wife with same-day delivery and it arrived looking absolutely spectacular — fresh, vibrant, and arranged beautifully. She was completely surprised and delighted. The personalized note card was a lovely touch. LVLY has completely spoiled me for any other flower delivery service. The premium is absolutely worth it for special occasions.",
      helpful: 167,
    },
    {
      name: 'Rachel L.',
      initials: 'RL',
      color: 'bg-fuchsia-500',
      badges: ['Verified', 'Regular Customer'],
      rating: 4,
      date: 'Dec 2025',
      text: "Regular LVLY customer here — I order at least monthly for different occasions. Quality is consistently excellent and the variety of hamper options keeps things interesting. The gourmet food hampers are particularly impressive with premium chocolates and artisanal selections. Slightly pricey but you genuinely get what you pay for. The only improvement I'd love is more weekend delivery slots.",
      helpful: 98,
    },
  ],
};
